export default function useClosable(closingId: string) {
  const closed = ref(false)

  onMounted(() => {
    if (import.meta.client) {
      if (closingId && localStorage.getItem(closingId)) {
        closed.value = true
      }
    }
  })

  function onClose() {
    if (closingId) {
      localStorage.setItem(closingId, 'true')
    }

    closed.value = true
  }

  return {
    closed,
    onClose,
  }
}
